export enum PaymentMethod {
  MPESA = "MPESA",
  BANK_DEPOSIT = "BANK_DEPOSIT",
  BANK_TRANSFER = "BANK_TRANSFER",
  CHEQUE = "CHEQUE",
  CASH = "CASH",
  BURSARY_CDF = "BURSARY_CDF",
}
